module.exports = __webpack_public_path__ + "assets/veritas_slider2.20dfc26a.jpg";